<template>
  <div class="sm-dropdown-wrap">
    <label
      v-if="label.length"
      class="sm-dropdown-label sm-small"
    >{{label}}</label>
    <dropdown-block 
      class="sm-dropdown"
      v-model="value" 
      :options="options"
      :multiple="params.multiple || false"
      :searchable="params.searchable || false"
      :allow-empty="params.allowEmpty || false"
      :close-on-select="params.closeOnSelect || true"
      placeholder=""
      :taggable="params.taggable || false"
      v-bind="{
        ...(params.trackBy ? { trackBy: params.trackBy } : {}),
        ...(params.label ? { label: params.label } : {})
      }"
      @input="$emit('input', value)"
      @tag="handleTag"
    >
      <template slot="placeholder">
        <span>
          {{placeholder}}
        </span>
        <include-svg :name="'icon-arrow-b'" />
      </template>
      <template slot="singleLabel" slot-scope="props">
        <span :class="capitalize ? 'sm-txt-capitalize' : ''">
          {{ props.option.name }}
        </span>
        <include-svg :name="'icon-arrow-b'" />
      </template>
      <template slot="option" slot-scope="props">
        <span :class="capitalize ? 'sm-txt-capitalize' : ''">
          <template v-if="params.taggable && params.tagItemTpl && props.search">
            {{ params.tagItemTpl.name }}{{ props.search }}
          </template>
          <template v-else>
            {{ props.option.name }}
          </template>
        </span>
      </template>
    </dropdown-block>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';

export default {
  name: 'dropdown-wrap',
  components: {
    "dropdown-block": Multiselect,
  },
  props: {
    val: {
      type: Object,
      default: () => new Object()
    },
    options: {
      type: Array,
      default: () => []
    },
    params: {
      type: Object,
      default: () => new Object()
    },
    placeholder: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    capitalize: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      value: false
    };
  },
  created() {
    if (Object.keys(this.val).length){
      this.value = this.val;
      this.$emit('input', this.value);
    }
  },
  methods: {
    handleTag(e) {
      if (!Number(e))
        return;

      let newItem = {};
      
      Object.keys(this.params.tagItemTpl).forEach(key => {
        newItem[key] = `${this.params.tagItemTpl[key]}${e}`
      });

      if (!this.options.find(opt => opt.name == newItem.name))
        this.options.unshift(newItem)

      this.value = newItem;

      this.$emit('tag', e);
    }
  },
  watch: {
    val() {
      this.value = this.val;
      this.$emit('input', this.value);
    }
  }
}
</script>